window.addEventListener('DOMContentLoaded', function () {
    const themeSelect    = document.getElementById('groupe-theme-select');
    const typeSelect     = document.getElementById('groupe-type-select');
    const resultsGrid    = document.getElementById('groupe-filter-results');
    const spinner        = document.getElementById('groupe-filter-spinner');

    if (!themeSelect || !typeSelect || !resultsGrid) return;

    function fetchResults() {
        const theme    = themeSelect.value;
        const postType = typeSelect.value;

        spinner && (spinner.style.display = 'flex');
        resultsGrid.style.opacity = '0.4';

        const body = new URLSearchParams({
            action:    'groupe_filter',
            theme:     theme,
            post_type: postType,
        });

        fetch('/wp-admin/admin-ajax.php', {
            method:  'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body:    body.toString(),
        })
        .then(r => r.json())
        .then(json => {
            if (json.success) {
                resultsGrid.innerHTML = json.data;
            }
        })
        .finally(() => {
            spinner && (spinner.style.display = 'none');
            resultsGrid.style.opacity = '1';
        });
    }

    themeSelect.addEventListener('change', fetchResults);
    typeSelect.addEventListener('change', fetchResults);

    // Chargement initial
    fetchResults();
});
